module.exports = __webpack_public_path__ + "img/DE01209.5d56fc84.png";